module.exports = __webpack_public_path__ + "static/media/nB1By5W6Ux.6c1af9b6.jpg";